import { JSX, useCallback, useEffect, useState } from "react";

import TextField from "@mui/material/TextField";

import { FormField } from "./FormTypes";

export type TextInputProps = {
	name?: string;
	label: string;
	field: FormField<string>;
	type?: "email" | "password" | "tel" | "text" | "url";
};

function TextInput(props: TextInputProps): JSX.Element {
	const [value, setValue] = useState(props.field.value);
	const [error, setError] = useState(props.field.error);

	useEffect(() => {
		if (props.field.value !== value) {
			setValue(props.field.value);
		}
	}, [props.field.value]);

	useEffect(() => {
		if (props.field.error !== error) {
			setError(props.field.error);
		}
	}, [props.field.error]);

	const onChange = useCallback(
		(event: React.ChangeEvent<HTMLInputElement>): void => {
			props.field.value = event.target.value;
			props.field.error = false;

			setValue(props.field.value);
			setError(props.field.error);
		},
		[props.field]
	);

	return (
		<TextField
			name={props.name}
			label={props.label}
			type={props.type}
			value={value}
			error={error}
			required={props.field.required}
			onChange={onChange}
			InputLabelProps={{ shrink: true }}
			variant="standard"
			fullWidth
		/>
	);
}

export default TextInput;
